import { identity, isEmpty, isNil, map, or, replace, sortBy, toLower, toUpper } from 'ramda'

// https://stackoverflow.com/questions/44497388/typescript-array-to-string-literal-type
export const literalStrings = <T extends string[]>(...strs: T) => strs

export const sortAlphabetically = (elements: string[], transformation: (str: string) => string = identity): string[] => sortBy(transformation, elements)

export const toString: StringConstructor = String

export const replaceSemicolon = (replacement: string, srt: string = "") => replace(';', replacement)(srt)

export const toUpperCase = (str?: string): string => toUpper(toString(str))

export const toLowerCase = (str?: string): string => toLower(toString(str))

export const capitalize = (str: string = ""): string => replace(/^./, toUpperCase)(str)

export const arraytoStrings = (...strs: any[]): string[] => map(toString, strs)

export const isNilOrEmpty = (obj) => or(isNil(obj), isEmpty(obj))

export const sortByAdapter = <T>(elements: T[], adapter: (element: T) => string): T[] => elements.sort((firstElement, nextElement) => adapter(firstElement).toLowerCase() < adapter(nextElement).toLowerCase() ? -1 : 1)

export const formattedCurrency = (value: number, decimals: number = 2): string => {
    const currencyFormat = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: decimals }) //Formats to "$ 123.456,789" 
    return `${currencyFormat.format(value)}`
  }
 
export const leadingZeroes = (data: string, count: number ) => `${Array(count).join("0")}${data}`.slice(count*(-1))

export const formattedNumber = (x: number): string => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const nonZeroNumber = (x: number): string => x === 0 ? '-' : x.toFixed(0);

export const formattedNoMoneyCurrency = (value: number, decimals: number = 2): string => {
  const currencyFormat = new Intl.NumberFormat('es-AR', { style: 'decimal', maximumFractionDigits: decimals, minimumFractionDigits: decimals }) //Formats to "$ 123.456,789" 
  return `${currencyFormat.format(value)}`
}

export const toPascalCase = (text: string): string => {
  if (typeof text !== 'string') {
    throw new Error('La entrada debe ser una cadena de texto');
  }
  return text
    .replace(/-/g, ' ') // Reemplazar guiones por espacios
    .toLowerCase()
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}